import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import { saveLabel, deleteLabel, getLabels, updateLabel } from "../api/LabelApi";

const api = {
  [ActionTypes.saveLabel]: (projectId, label) => saveLabel(projectId, label),
  [ActionTypes.updateLabel]: (projectId, labelId, label) => updateLabel(projectId, labelId, label),
  [ActionTypes.deleteLabel]: (projectId, labelId) => deleteLabel(projectId, labelId),
  [ActionTypes.getLabels]: (projectId, type) => getLabels(projectId, type),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
